import "../styles/application.css"
import { mountVueComponents } from "../vue/mount"

// No Turbo in this app, so a plain DOMContentLoaded is all we need.
document.addEventListener("DOMContentLoaded", () => {
  mountVueComponents()
})
